import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path fill=\"#fff\" d=\"M0 8a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z\"></path><g stroke=\"var(--color-gray-03)\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"1.5\" clip-path=\"url(#a)\"><path d=\"M10.75 18.25v-2.333a2.333 2.333 0 1 1 2.333 2.333zM12.063 18.25h8.75\"></path><path d=\"M21.25 7.75a9.33 9.33 0 0 0-7.467 5.95M21.25 7.75a9.33 9.33 0 0 1-5.95 7.467\"></path><path d=\"M15.184 11.25a5.25 5.25 0 0 1 2.566 2.567\"></path></g><rect width=\"19\" height=\"3\" x=\"6.5\" y=\"22.5\" fill=\"#fff\" stroke=\"var(--color-gray-02)\" rx=\"1.5\"></rect><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M9 6h14v14H9z\"></path></clipPath></defs>", 4)
  ]))]))
}
export default { render: render }